import type { ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';
import { cn } from '@/lib/cn';

interface SectionLabelProps {
  icon?: LucideIcon;
  children: ReactNode;
  className?: string;
  aside?: ReactNode;
}

export function SectionLabel({ icon: Icon, children, aside, className }: SectionLabelProps) {
  return (
    <div className={cn('mb-3 flex items-center justify-between gap-3', className)}>
      <div className="section-label !mb-0">
        {Icon ? <Icon className="h-3.5 w-3.5" aria-hidden="true" /> : null}
        <span>{children}</span>
      </div>
      {aside ? <div className="text-xs text-muted-foreground">{aside}</div> : null}
    </div>
  );
}
